<template>
  <div id="app">
    <Landing />
    <SadWindows />
  </div>
</template>

<script>
import Landing from './assets/eov/Landing.vue'
import SadWindows from './assets/sad windows/SadWindows.vue'

export default {
  components: {
    Landing: Landing,
    SadWindows: SadWindows
  },
  data () {
    return {
      booted: false
    }
  },
  computed: {
    isDesktop () {
      return window.innerWidth > 1280 ? true : false
    }
  }
}
</script>

<style>
body {
  margin: 0;
  overflow-x: hidden;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size-adjust: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue